// removed by extract-text-webpack-plugin
module.exports = {"primary_layout":"primary_layout__OSonY","primary_box":"primary_box__21eC6"};


//////////////////
// WEBPACK FOOTER
// ./components/live-panel/style.scss
// module id = SAA0
// module chunks = 0